import List from './List'

const carsBrakeResource = {
  list: List,
}

export default carsBrakeResource
